class MbiiConfigurator extends HTMLElement {
  constructor() {
    super()

    this.modelFaceImageUrl = null

    this.bindMethods()
    this.setupEls()
    this.setupListeners()
  }

  bindMethods() {
    this.onStartClick = this.onStartClick.bind(this)
  }

  setupEls() {
    this.startEl = this.querySelector('[data-el="mbii.startButton"]')
    this.introductionEl = this.querySelector('[data-el="mbii.introduction"]')
  }

  setupListeners() {
    if (!this.startEl || !this.introductionEl) return
    this.startEl.addEventListener('click', this.onStartClick)
  }

  onStartClick() {
    if (!this.introductionEl) return
    this.introductionEl.setAttribute('aria-hidden', 'true')
  }

}

customElements.define('mbii-configurator', MbiiConfigurator)
